export default function PaperPlaneIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M11.8498 9.93542L26.8832 4.91876C33.6332 2.66876 37.2998 6.35209 35.0665 13.1021L30.0498 28.1354C26.6832 38.2521 21.1498 38.2521 17.7832 28.1354L16.2998 23.6688L11.8332 22.1854C1.73317 18.8354 1.73317 13.3188 11.8498 9.93542Z"
        fill="url(#paint0_linear_17038_864)"
      />
      <path d="M20.2002 19.3823L26.5502 13.0156L20.2002 19.3823Z" fill="url(#paint1_linear_17038_864)" />
      <path
        d="M20.1999 20.6359C19.8833 20.6359 19.5666 20.5193 19.3166 20.2693C18.8333 19.7859 18.8333 18.9859 19.3166 18.5026L25.6499 12.1359C26.1333 11.6526 26.9333 11.6526 27.4166 12.1359C27.8999 12.6193 27.8999 13.4193 27.4166 13.9026L21.0833 20.2693C20.8333 20.5026 20.5166 20.6359 20.1999 20.6359Z"
        fill="url(#paint2_linear_17038_864)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_17038_864"
          x1="32.5793"
          y1="19.9902"
          x2="7.84366"
          y2="18.9522"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0BAAA1" />
          <stop offset="1" stopColor="#0B8DAA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_17038_864"
          x1="25.9161"
          y1="16.1989"
          x2="20.9234"
          y2="15.9899"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0BAAA1" />
          <stop offset="1" stopColor="#0B8DAA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_17038_864"
          x1="26.8978"
          y1="16.2046"
          x2="19.9592"
          y2="15.9147"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0BAAA1" />
          <stop offset="1" stopColor="#0B8DAA" />
        </linearGradient>
      </defs>
    </svg>
  );
}
